// 작성 위젯 표시 라벨 규칙 — 미배치 풀 행·트리 행·우클릭 목록이 공유하는 정본.

import { REGISTERED_FORM_WIDGETS_META, type InputWidget } from '@safetyhub/shared';

/**
 * 입력 위젯의 표시 라벨(미배치 풀 행·트리 행·우클릭 목록 공용 정본) — kind 배지가 이미 widget 타입을
 * 보여주므로 타입 접미 없이 라벨만.
 * 등록형도 **운영자가 지정한 label을 우선**한다 — 트리 행 더블클릭 rename이 label을 저장하는데
 * 카탈로그 라벨만 표시하면 "고쳤는데 화면이 그대로"로 보인다(2026-07-22 리뷰 지적). 미지정 시 카탈로그 라벨.
 */
export function composerInputPrimaryLabel(w: InputWidget): string {
  // ⚠️ 빈 문자열·공백도 "미지정"으로 취급(`??`가 아니라 trim 판정) — 저장된 label이 ''인 위젯이 실제로
  // 있고(dev `ra-criteria-detail`), 예전 상시 input 시절엔 placeholder(bindingKey)가 보였지만 읽기 전용
  // 텍스트로 바꾼 뒤엔 행이 통째로 빈칸이 된다. 그러면 그 span은 높이 0이라 **더블클릭 대상조차
  // 사라져** rename이 불가능해진다(2026-07-22 사용자 제보).
  const own = w.label?.trim() ? w.label : undefined;
  if (w.widget === 'registered') {
    const meta = REGISTERED_FORM_WIDGETS_META.find((m) => m.key === w.widgetKey);
    return own ?? meta?.label ?? w.widgetKey ?? '(위젯)';
  }
  return own ?? w.bindingKey;
}
